/** File name from a Content-Disposition header value, or the fallback when the header names none. */
export function fileNameFromContentDisposition(header: string | null | undefined, fallback: string): string {
  const match = /filename="?([^";]+)"?/i.exec(header ?? '');
  return match?.[1]?.trim() || fallback;
}

export function downloadFile(data: any, type: string, filename?: string) {
  let blob = new Blob([data], { type: type });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}
